module.exports = __webpack_public_path__ + "static/media/pencil.f4978220.svg";